import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState, TListId } from '../../../types/types';
import { listPatchRest } from './api/helpers/listPatchRest';

export const listSetMaxCardNumber = (
    listId: TListId,
    maxCardNumber: number,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(listPatchRest(listId, {maxCardNumber}));
    };
    return action;
}
